export const SUCC_CODE = 0

export const TIMEOUT = 10000;


// WEBPACK FOOTER //
// ./src/api/config.js